import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ApiKey } from '@shared/models/api-management/api-key';
import { createReducer, on } from '@ngrx/store';
import * as apiManagementActions from '../actions/api-managment.actions';
import { ScopeGroup } from '@shared/models/api-management/scope-group';
import { Pagination } from '@shared/pagination';

export const API_MANAGEMENT = 'api-management';

export const apiKeysAdapter: EntityAdapter<ApiKey> = createEntityAdapter<ApiKey>({});

export interface ApiKeysState extends EntityState<ApiKey> {
  loaded: boolean;
  loading: boolean;
  pagination: Pagination<ApiKey>;
}

export const apiKeysInitialState = apiKeysAdapter.getInitialState({
  loaded: false,
  loading: false,
  pagination: {},
});

export const apiKeysReducer = createReducer(
  apiKeysInitialState,
  on(apiManagementActions.loadApiKeys, (state) =>
    apiKeysAdapter.removeAll({
      ...state,
      loading: true,
      loaded: true,
    }),
  ),
  on(apiManagementActions.loadApiKeysSuccess, (state, { apiKeysPage }) =>
    apiKeysAdapter.setAll(apiKeysPage.content, {
      ...state,
      loading: false,
      loaded: false,
      pagination: apiKeysPage,
    }),
  ),
  on(
    apiManagementActions.updateApiKeySuccess,
    apiManagementActions.revokeApiKeySuccess,
    apiManagementActions.activateApiKeySuccess,
    (state, { apiKey }) => apiKeysAdapter.upsertOne(apiKey, state),
  ),
);

export const scopeGroupsAdapter: EntityAdapter<ScopeGroup> = createEntityAdapter<ScopeGroup>({});

export interface ScopeGroupsState extends EntityState<ScopeGroup> {
  loaded: boolean;
  loading: boolean;
}

export const scopeGroupsInitialState = scopeGroupsAdapter.getInitialState({
  loaded: false,
  loading: false,
});

export const scopeGroupsReducer = createReducer(
  scopeGroupsInitialState,
  on(apiManagementActions.loadScopeGroups, (state) =>
    scopeGroupsAdapter.removeAll({
      ...state,
      loading: true,
      loaded: true,
    }),
  ),
  on(apiManagementActions.loadScopeGroupsSuccess, (state, { scopeGroups }) =>
    scopeGroupsAdapter.setAll(scopeGroups, {
      ...state,
      loading: false,
      loaded: true,
    }),
  ),
);

export interface ApiManagementState {
  apiKeys: ApiKeysState;
  scopeGroups: ScopeGroupsState;
}

export const apiManagementReducer = {
  apiKeys: apiKeysReducer,
  scopeGroups: scopeGroupsReducer,
};
